import React from "react";
import "./Styles/BoxLoader.css";

interface LoaderProps {
  text: string;
}
const BoxLoading = ({ text }: LoaderProps) => {
  return (
    <div className="spinner-container">
      <div className="box-spinner">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
      <p className="spinner-text">{text}</p>
    </div>
  );
};

export default BoxLoading;
